export const API = "AIzaSyC-zL5I_XHUqU6MwZL6DlAPBSoGkhBPTRs";

export const cx = "256f630ff0c2e4399";